<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">Add Instrument</h5>
    <form [formGroup]="AddNewDevice">

      <input type="hidden" formControlName="id" />

      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Instrument Name (Latin) </label>
          <input formControlName="Title" type="text" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_Title().valid && get_Form_Title().touched"
            class="form-text text-muted MyErrorRedColor">Enter the instrument name in Latin characters.</small>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"><button type="button" (click)="openModal_QUANTITY(templateQUANTITY)"
              class="btn btn-danger left"> Select Subquantity <i class="fa fa-lastfm-square"></i> </button> </label>
          <input type="text" class="form-control" disabled value="{{Data_Seleted_Record.title}}" />
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">OBSERVATION </label>
          <input formControlName="observation" type="number" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_observation().valid && get_Form_observation().touched"
            class="form-text text-muted MyErrorRedColor">Enter the observation.</small>
        </div>

      </div>

    </form>

    <br />
    <hr />
    <br />
    <h5> MPE</h5>

    <form [formGroup]="MPEDevice" (submit)="Submit_MPEDevice_Form()">

      <input type="hidden" formControlName="id" />

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> Minimum Nominal Value </label>
          <input formControlName="Mpe_Min" type="number" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_MPEDevice_Mpe_Min().valid && get_Form_MPEDevice_Mpe_Min().touched"
            class="form-text text-muted MyErrorRedColor">Enter the minimum nominal value.</small>
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> Nominal Value Max </label>
          <input formControlName="Mpe_Max" type="number" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_MPEDevice_Mpe_Max().valid && get_Form_MPEDevice_Mpe_Max().touched"
            class="form-text text-muted MyErrorRedColor">Enter the maximum nominal value.</small>
        </div>

      </div>
      <div class="row">

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Maximum Permissible Systematic Error </label>
          <input formControlName="Mpe_Sys" type="number" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_MPEDevice_Mpe_Sys().valid && get_Form_MPEDevice_Mpe_Sys().touched"
            class="form-text text-muted MyErrorRedColor">Enter the maximum permissible systematic error.</small>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Maximum Permissible Random Error </label>
          <input formControlName="Mpe_Rnd" type="number" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_MPEDevice_Mpe_Rnd().valid && get_Form_MPEDevice_Mpe_Rnd().touched"
            class="form-text text-muted MyErrorRedColor">Enter the maximum permissible random error.</small>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Target Uncertainty</label>
          <input formControlName="Mpe_Goal" type="number" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_MPEDevice_Mpe_Goal().valid && get_Form_MPEDevice_Mpe_Goal().touched"
            class="form-text text-muted MyErrorRedColor">Enter the target uncertainty.</small>
        </div>
      </div>

      <button *ngIf="!InProccessing" type="submit" [disabled]="!MPEDevice.valid" class="btn btn-info"
        style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add MPE </button>
    </form>

    <br />
    <br />

    <div class="table-responsive" *ngIf="Device_MPE_List.length>0">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>Nominal Value</th>
            <th>Maximum Permissible Systematic Error </th>
            <th>Maximum Permissible Random Error </th>
            <th>Target Uncertainty</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of Device_MPE_List">
            <td>{{Device_MPE_List.indexOf(item)+1}}</td>
            <td>From {{item.mpe_min}} to {{item.mpe_max}}</td>
            <td>{{item.mpe_sys}}</td>
            <td>{{item.mpe_rnd}}</td>
            <td>{{item.mpe_goal}}</td>
            <td>
              <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                <div class="btn-group" role="group">
                  <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Actions
                  </button>
                  <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                    <a style="cursor: pointer;" (click)="Delete_Device_MPE_List(Device_MPE_List.indexOf(item))"
                      class="dropdown-item"><i class="fa fa-remove"></i> Delete </a>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <br />
    <hr />
    <br />

    <h5 *ngIf="List_MANUFACTURE_Edit_Id==-1"> Manufacturer and Model </h5>
    <h5 *ngIf="List_MANUFACTURE_Edit_Id>-1"> Edit Manufacturer and Model </h5>

    <br />

    <form [formGroup]="Device_MANUFACTURE_FORM" (submit)="Submit_Device_MANUFACTURE_FORM()">

      <input type="hidden" formControlName="id" value="0" />

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> MANUFACTURE </label>
          <input formControlName="MANUFACTURE" type="text" style="font-family: Arial, Helvetica, sans-serif;"
            class="form-control EnglishClm" placeholder="Type here...">
          <small
            *ngIf="!get_Device_MANUFACTURE_FORM_MANUFACTURE().valid && get_Device_MANUFACTURE_FORM_MANUFACTURE().touched"
            class="form-text text-muted MyErrorRedColor">Enter the manufacturer.</small>
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> MODEL </label>
          <input formControlName="MODEL" type="text" style="font-family: Arial, Helvetica, sans-serif;"
            class="form-control EnglishClm" placeholder="Type here...">
          <small *ngIf="!get_Device_MANUFACTURE_FORM_MODEL().valid && get_Device_MANUFACTURE_FORM_MODEL().touched"
            class="form-text text-muted MyErrorRedColor">Enter the model.</small>
        </div>
      </div>


      <button *ngIf="!InProccessing && List_MANUFACTURE_Edit_Id>-1" type="submit"
        [disabled]="!Device_MANUFACTURE_FORM.valid" class="btn btn-info" style="margin-right: 5px;"><i
          class="fa  fa-plus-circle"></i> Edit Manufacturer and Model </button>
      <button *ngIf="!InProccessing && List_MANUFACTURE_Edit_Id>-1" (click)="Reset_MANUFACTURE()" type="button"
        class="btn btn-danger" style="margin-right: 5px;"><i class="fa fa-times-rectangle"></i> Cancel Editing </button>

    </form>

    <br />
    <hr />
    <br />


    <div>

      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">
            Mapping ( jpeg , png , jpg )
            <button (click)="Remove_uploadImage1()" type="button" *ngIf="UploadImageSrc" class="btn  btn-danger"><i
                class="fa  fa-times-rectangle"></i> </button>
          </label>
          <img *ngIf="InProccessing_Image1" src="assets/Loading.gif" style="width: 25px;" />
          <input *ngIf="!InProccessing_Image1" #file_Image1 (change)="uploadImage1(file_Image1.files)" type="file"
            class="form-control" placeholder="Type here...">
        </div>
      </div>

      <button type="button" (click)="Add_uploadImage1()" [disabled]="!UploadImageSrc" class="btn btn-info"
        style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add Attachment </button>

      <br />
      <br />

    </div>

    <div class="table-responsive" *ngIf="UploadImageSrc_List.length>0">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            
            <th>Title</th>
            <th>File</th>

            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of UploadImageSrc_List">

            <td>{{UploadImageSrc_List.indexOf(item.title)+1}}</td>
            <td>
              <input type="text" [(ngModel)]="item.dsc" />
            </td>
            <td>
              <img (click)="openModal(templateImage,item.title)"
                style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Device/{{item.title}}" />
            </td>
            <td>
              <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                <div class="btn-group" role="group">
                  <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Actions
                  </button>
                  <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                    <a style="cursor: pointer;" (click)="UploadImageSrc_List_Delete(UploadImageSrc_List.indexOf(item))"
                      class="dropdown-item"><i class="fa fa-remove"></i> Delete </a>
                  </div>
                </div>
              </div>
            </td>

          </tr>
        </tbody>
      </table>
    </div>



    <br />
    <hr />
    <br />

    <h5>Manufacturer and Model Details</h5>

    <br />

    <form [formGroup]="Device_MANUFACTURE_Detail_FORM" (submit)="Submit_Device_MANUFACTURE_Detail_FORM()">

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> RESOLUTION </label>
          <input formControlName="RESOLUTION" type="text" class="form-control EnglishClm"
            style="font-family: Arial, Helvetica, sans-serif;" placeholder="Type here...">
          <small
            *ngIf="!get_Device_MANUFACTURE_FORM_RESOLUTION().valid && get_Device_MANUFACTURE_FORM_RESOLUTION().touched"
            class="form-text text-muted MyErrorRedColor">Enter the resolution.</small>
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> Unit </label>
          <select class="custom-select" formControlName="RESOLUTION_Vahed_id">
            <option value="0">Select</option>
            <option *ngFor="let item of DataList_Unit" [value]="item.id">
              <div innerHTML="{{item.title}}"></div>

            </option>
          </select>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> RANGE MIN </label>
          <input formControlName="RANGE_MIN" type="text" class="form-control EnglishClm"
            style="font-family: Arial, Helvetica, sans-serif;" placeholder="Type here...">
          <small
            *ngIf="!get_Device_MANUFACTURE_FORM_RANGE_MIN().valid && get_Device_MANUFACTURE_FORM_RANGE_MIN().touched"
            class="form-text text-muted MyErrorRedColor">Enter the minimum range.</small>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> RANGE MAX </label>
          <input formControlName="RANGE_MAX" type="text" class="form-control EnglishClm"
            style="font-family: Arial, Helvetica, sans-serif;" placeholder="Type here...">
          <small
            *ngIf="!get_Device_MANUFACTURE_FORM_RANGE_MAX().valid && get_Device_MANUFACTURE_FORM_RANGE_MAX().touched"
            class="form-text text-muted MyErrorRedColor">Enter the maximum range.</small>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Unit </label>
          <select class="custom-select" formControlName="RANGE_Vahed_id">
            <option value="0">Select</option>
            <option *ngFor="let item of DataList_Unit" [value]="item.id">
              <div innerHTML="{{item.title}}"></div>
            </option>
          </select>
        </div>
      </div>

      <button type="submit" [disabled]="!Device_MANUFACTURE_Detail_FORM.valid" class="btn btn-success"
        style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add to Table </button>
      <button *ngIf="!InProccessing" type="reset" class="btn btn-danger" style="margin-right: 5px;"><i
          class="fa fa-times-rectangle"></i> Cancel </button>


      <div class="table-responsive" *ngIf="Device_MANUFACTURE_Detail_List.length>0">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>RESOLUTION</th>
              <th>RANGE</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of Device_MANUFACTURE_Detail_List">
              <td>{{Device_MANUFACTURE_Detail_List.indexOf(item)+1}}</td>
              <td class="EnglishClm">{{item.rESOLUTION}} <div innerHTML="{{item.rESOLUTION_Vahed}}"></div>
              </td>
              <td class="EnglishClm"> {{item.rANGE_MIN}} ... {{item.rANGE_MAX}} <div innerHTML="{{item.rANGE_Vahed}}">
                </div>
              </td>
              <td>
                <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                  <div class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Actions
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                      <a style="cursor: pointer;"
                        (click)="Delete_List_MANUFACTURE_Detail(Device_MANUFACTURE_Detail_List.indexOf(item))"
                        class="dropdown-item"><i class="fa fa-remove"></i> Delete </a>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </form>



    <br />
    <hr />
    <br />

    <button *ngIf="!InProccessing && List_MANUFACTURE_Edit_Id==-1" type="button"
      (click)="Submit_Device_MANUFACTURE_FORM()" [disabled]="!Device_MANUFACTURE_FORM.valid" class="btn btn-info"
      style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add Manufacturer and Model with Details </button>

    <br />
    <br />

    <div class="table-responsive" *ngIf="Device_MANUFACTURE_List.length>0 && List_MANUFACTURE_Edit_Id==-1">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>MANUFACTURE</th>
            <th>MODEL</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let item of Device_MANUFACTURE_List">
            <tr>
              <td>{{Device_MANUFACTURE_List.indexOf(item)+1}}</td>
              <td class="EnglishClm">{{item.mANUFACTURE}}</td>
              <td class="EnglishClm">{{item.mODEL}}</td>
              <td>
                <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                  <div class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Actions
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                      <a style="cursor: pointer;" (click)="Edot_List_MANUFACTURE(Device_MANUFACTURE_List.indexOf(item))"
                        class="dropdown-item"><i class="fa fa-edit"></i> Edit </a>
                      <a style="cursor: pointer;"
                        (click)="Delete_List_MANUFACTURE(Device_MANUFACTURE_List.indexOf(item))"
                        class="dropdown-item"><i class="fa fa-remove"></i> Delete </a>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                <table class="mb-0 table table-bordered table-3 text-center table-striped">
                  <thead style="background-color: #393b9b; color: white;">
                    <tr>
                      <th>#</th>
                      <th>RESOLUTION</th>
                      <th>RANGE</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let itemDetail of item.detail">
                      <td class="EnglishClm">{{item.detail.indexOf(itemDetail)+1}}</td>

                      <td class="EnglishClm">{{itemDetail.rESOLUTION}} <div innerHTML="{{itemDetail.rESOLUTION_Vahed}}">
                        </div>
                      </td>
                      <td class="EnglishClm"> {{itemDetail.rANGE_MIN}} ... {{itemDetail.rANGE_MAX}} <div
                          innerHTML="{{itemDetail.rANGE_Vahed}}"></div>
                      </td>

                      <td>
                        <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                          <div class="btn-group" role="group">
                            <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              Actions
                            </button>
                            <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                              <a style="cursor: pointer;"
                                (click)="Delete_List_MANUFACTURE_Detail_INLIST(item.detail.indexOf(itemDetail),Device_MANUFACTURE_List.indexOf(item))"
                                class="dropdown-item"><i class="fa fa-remove"></i> Delete </a>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>

                  </tbody>
                </table>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    <br />
    <hr />
    <br />

    <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!InProccessing" type="button" (click)="SubmitAddNewDevice()" [disabled]="!AddNewDevice.valid"
      class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>
    <button routerLink="/Device" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i
        class="fa fa-mail-reply"></i> Back </button>
  </div>
</div>

<ng-template #templateQUANTITY>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Subquantity List</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_QUANTITY.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Title Subquantity </label>
          <input type="text" class="form-control" [(ngModel)]="Search_Name_QUANTITY_Table"
            placeholder="Type here to search...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Measurement Quantity</th>
              <th>Subquantity</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_QUANTITY
            |filter:Search_Name_QUANTITY_Table:'title'
            | paginate
                    : {
                        id: 'DataList_QUANTITY',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_QUANTITY|filter:Search_Name_QUANTITY_Table:'title').length
                      }">
              <td>{{DataList_QUANTITY.indexOf(item)+1}}</td>
              <td>{{item.parentTitle}}</td>
              <td>{{item.title}}</td>
              <td (click)="Set_Selected_QUANTITY_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> Select</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingQUANTITY" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!ProcssingQUANTITY" type="button" (click)="ReadData_QUANTITY()" class="btn btn-info"
      style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_QUANTITY.hide()">Close</button>
  </div>
</ng-template>


<ng-template #templateImage>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> View Image </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Image.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body" style="text-align: center;">
    <img style="max-width: 350px;" src="{{BaseUrl}}File/Device/{{ModalimageUrl}}" />
  </div>
  <div class="modal-footer">
    <a class="dropdown-item" target="_blank" href="{{BaseUrl}}File/Device/{{ModalimageUrl}}"><i
        class="fa fa-download"></i> Download </a>
    <button type="button" class="btn btn-danger" (click)="modalRef_Image.hide()">Close</button>
  </div>
</ng-template>
